import { useCallback, useState } from 'react';
import { getActiveCancelRequestTimestamp, recordCancelRequest } from '../utils/cancellationRequestStorage';
export function useCancellationRequestCooldown(objectId) {
  const [requestedAt, setRequestedAt] = useState(() => getActiveCancelRequestTimestamp(objectId));
  const markRequested = useCallback(() => {
    const now = Date.now();
    recordCancelRequest(objectId, now);
    setRequestedAt(now);
  }, [objectId]);
  return {
    isInCooldown: requestedAt !== null,
    markRequested
  };
}